var render, staticRenderFns
import script from "./TableHandler.vue?vue&type=script&lang=js"
export * from "./TableHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355e2f9",
  null
  
)

export default component.exports